<template>
  <div class="about">
    <LivrateurHeader />
    <LivrateurBody />
    <div class="my-5 pt-5">
      <ContactUsAction />
    </div>
    <LivrateurTuto />
  </div>
</template>

<script>
import { useMeta } from "vue-meta";
import LivrateurHeader from "@/components/services/LivrateurHeader.vue";
import LivrateurBody from "@/components/services/LivrateurBody.vue";
import LivrateurTuto from "@/components/services/LivrateurTuto.vue";
import ContactUsAction from "@/components/partials/ContactUsAction.vue";

export default {
  name: "AboutView",
  components: {
    LivrateurHeader,
    LivrateurBody,
    LivrateurTuto,
    ContactUsAction,
  },
  mounted() {
    // Si tu utilises déjà ton observer global pour les animations :
    import("@/assets/globalJs/global.js").then(({ observeElements }) => {
      observeElements(
        ".slide-right",
        ".slide-left",
        ".fall-down",
        ".image-fade-in"
      );
    });
  },
  setup() {
    useMeta({
      title: "Missions pour livreurs BTP – Rejoignez la plateforme Livratos",
      description: [
        {
          content:
            "Rejoignez Livratos en tant que livreur et accédez à des missions de livraison de matériaux BTP entre fournisseurs et artisans, avec une rémunération claire et un planning flexible.",
        },
      ],
      link: [
        {
          rel: "canonical",
          href: "https://www.livratos.fr/missions-pour-livreurs",
        },
      ],
    });
  },
};
</script>
